import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PendingInvoicesRepository } from '../../../domain/repositories/pending-invoices/pending-invoices.repository';
import { PendingInvoicesApiResponse } from '../../../domain/interfaces/pending-invoices/pending-invoices.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

@Injectable()
export class PendingInvoicesRepositoryImplementation extends PendingInvoicesRepository {
  private readonly http = inject(HttpClientService);

  override getInvoices(userId: string): Observable<PendingInvoicesApiResponse> {
    return this.http.getRaw<PendingInvoicesApiResponse>(API_ENDPOINTS.pendingInvoices.list(userId));
  }
}
